export default __webpack_public_path__ + "static/media/four.667b0883.jpg";